import { DOMAIN } from 'config';
import { LoginCredentials, Login, LoginContext, LoginContextApi } from '../types';
import { saveUserData, saveToken, deleteUserData, getUserData } from './storage';
const userDataTransform = (user: LoginContextApi): LoginContext => {
  if (!user) {
    return user;
  }
  return {
    id: user.Id,
    name: user.Name,
    organizationType: user.OrganizationTypeId,
    organizationName: user.Organization.Name,
    email: user.Email,
    roleNames: user.RoleNames,
    designerOrganizationName: user.Organization.Name,
    designerOrganizationId: user.Organization.Id,
    brands: user.Brands,
    organizationId: user.OrganizationId,
    signUpDate: user.SignUpDate?.replace(/[^0-9.]/g, '') || '',
    planType: user.PlanType,
    planTier: user.PlanTier,
    platformNewsletterSubscription: user.PlatformNewsletterSubscription,
    inviteCode: user.Organization.InviteCode,
  };
};

export const userFn = async (): Promise<Login> => {
  const user = getUserData();
  const response = await fetch(`${DOMAIN}/LoggedInUser`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    return null;
  }
  const data = await response.json();
  const loginContext = userDataTransform(data);
  saveToken(loginContext);
  return {
    user: user.userData || null,
    loginContext,
  };
};

export const loginFn = async (user: LoginCredentials) => {
  const response = await fetch(`${DOMAIN}/betalogin`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(user),
  });
  if (!response.ok) {
    const result = await response.json();
    // Extract error message from the response
    throw new Error(result.Message || `Error: ${response.status} ${response.statusText}`);
  }
  const data = await response.json();
  if (data.Message && data.Status === 'error') {
    throw new Error(data.Message || `Error: ${data.Message} ${data.Status}`);
  }
  saveUserData(data);
  if (!data.isMultiselect) {
    const tokenLogin = await tokenFn({
      ...user,
      loginContext: data.loginContexts[0],
      user: data,
    });
    return tokenLogin;
  }
  const login: Login = {
    user: data,
    token: null,
    ...user,
  };
  return login;
};

export const logoutFn = async () => {
  deleteUserData();
  await fetch(`${DOMAIN}/betalogin/logout`, {
    method: 'GET',
    credentials: 'include',
  });
  return;
};

// eslint-disable-next-line require-await
export const registerFn = async () => {
  return null;
};

export const tokenFn = async (user: LoginCredentials) => {
  const id = user.loginContext?.id || 0;
  const orgId =
    user.loginContext?.organizationType === 1 ? 0 : user.loginContext?.designerOrganizationId;
  const response = await fetch(
    `${DOMAIN}/betalogin/select/${id}?designerorgid=${orgId}&rememberme=${user.RememberMe}`,
    {
      method: 'GET',
      credentials: 'include',
    }
  );
  if (!response.ok) {
    throw new Error('Error logging in.');
  }
  const data = await response.json();
  saveToken(user.loginContext);
  const login: Login = {
    user: user.user,
    token: data,
    loginContext: user.loginContext,
    Username: user.Username,
    Password: user.Password,
  };
  return login;
};
